import tokens from 'airship-design-system/tokens.json'

export type Space = keyof typeof tokens.spacing

/* Transforms this:

  "spacing": {
    "0": {
      "value": 0,
      "type": "spacing"
    },
    "1": {
      "value": "4px",
      "type": "spacing"
    },

  Into this:

    "0": 0,
    "1": "4px",

*/
const spacing: Record<Space, string | number> = Object.keys(
  tokens.spacing
).reduce((obj, key) => {
  obj[key as Space] = tokens.spacing[key as Space].value
  return obj
}, {} as Record<Space, string | number>)

export default spacing
